import React from "react";

import { uniqueId } from "lodash";

export default function useStableId(prefix = "") {
  return React.useMemo(() => uniqueId(prefix), [prefix]);
}
